import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AxsButtonComponent } from '@vanguard/axs-angular';
import { ContentService } from 'src/app/shared/services/content/content.service';
import { content } from 'src/assets/content/fallback-content';

import { AdobeLaunchService } from '../../adobe-launch/adobe-launch.service';

@Component({
  selector: 'client-ready-resources-v4',
  standalone: true,
  imports: [AxsButtonComponent, CommonModule],
  templateUrl: './client-ready-resources-v4.component.html',
  styleUrl: './client-ready-resources-v4.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ClientReadyResourcesV4Component {
  clientReadyResourcesContent = content.Data.v4_rcc_root.content.clientReadyResources;
  downloadText = content.Data.v4_rcc_root.content.common.download;

  constructor(
    private readonly adobeLaunchService: AdobeLaunchService,
    private readonly contentService: ContentService,
  ) {
    this.contentService.getContent().subscribe((data) => {
      this.clientReadyResourcesContent = data.Data.v4_rcc_root.content.clientReadyResources;
      this.downloadText = data.Data.v4_rcc_root.content.common.download;
    });
  }

  public adobeTaggingPDFDownloadEvent(pdfFile): void {
    const fileName = `${pdfFile}`;
    this.adobeLaunchService.downloadAction(fileName);
  }
}
